import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/sealApply',
    meta: { title: '用印申请' },
    component: Layout,
    redirect: '/sealApply/list',
    children: [
      {
        path: 'list',
        meta: { title: '用印申请', activeMenu: '/sealApply' },
        component: () => import('@/views/sealApply/SealApply.vue')
      },
      {
        path: 'add',
        meta: { title: '发起用印申请', activeMenu: '/sealApply' },
        component: () => import('@/views/sealApply/SealApplyAdd.vue')
      },
      {
        path: 'detail',
        meta: { title: '用印申请详情', activeMenu: '/sealApply' },
        component: () => import('@/views/sealApply/SealApplyDetail.vue')
      }
    ]
  }
]
